import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { setProjectDetail } from "../../store/modules/appState/actions";
import SignOutContainer from "../../containers/SignInContainer/SignOut";
import bvaLogo from "../../assets/bva-logo.png";
import FinancialHandler from "../../handlers/FinancialHandler";
import Swal from "sweetalert2";

const Navbar = ({ user, companyDataValid, dispatchSetProjectDetail }) => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  const saveProject = async () => {
    const projectDetail = await FinancialHandler.saveProjectData();
    dispatchSetProjectDetail(projectDetail);
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Your project is saved successfully!"
    });
  }

  return (
    <div>
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          <NavLink to="/" className="nav-logo">
            <img
              style={{ width: "120px" }}
              src={bvaLogo}
              alt="Business Valuation Advisors logo"
            />
          </NavLink>
        </div>
        <div className="flex justify-end items-center w-full">
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            {/* <li
              className={`nav-item ${
                companyDataValid === "true" ? "" : "disabled"
              }`}
            >
              <NavLink
                to="/bvatool"
                className="nav-links"
                onClick={click ? handleClick : null}
              >
                BVA Statistics Tool
              </NavLink>
            </li> */}
            <li
              className={`nav-item ${
                companyDataValid === "true" ? "" : "hidden"
              }`}
            >
              <NavLink
                className="nav-links"
                onClick={saveProject}
              >
                Save Project
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/projects"
                className="nav-links"
                onClick={click ? handleClick : null}
              >
                All Projects
              </NavLink>
            </li>
            <li
              className={`nav-item ${
                companyDataValid === "true" ? "" : "disabled"
              }`}
            >
              <NavLink
                to="/"
                className="nav-links"
                onClick={click ? handleClick : null}
              >
                Dashboard
              </NavLink>
            </li>
            <li
              className={`nav-item ${
                companyDataValid === "true" ? "" : "disabled"
              }`}
            >
              <NavLink
                to="/reports"
                className="nav-links"
                onClick={click ? handleClick : null}
              >
                Reports
              </NavLink>
            </li>
          </ul>
          <div className="flex items-center">
            <span className="nav-user">
              <span className="nav-user-name">{user.firstName || ""}</span>
              <span className="nav-user-email">{user.email}</span>
            </span>
            <div className="nav-profile">
              <div className="nav-profile-icon">
                <i className="fa fa-user"></i>
              </div>
              <div className="nav-profile-dropdown">
                <div className="nav-profile-dropdown-item">
                  {/* <NavLink to="/profile" className="nav-links">
                    Profile
                  </NavLink> */}
                  <NavLink to="/settings" className="nav-links">
                    Settings
                  </NavLink>
                  {/* <NavLink to="/subscription-settings" className="nav-links">
                    Subscription
                  </NavLink> */}
                  {user?.role === "admin" &&
                    <>
                      <NavLink to="/admin-settings" className="nav-links">
                        AdminSettings
                      </NavLink>
                      {/* <NavLink to="/admin-stripe" className="nav-links">
                        AdminStripe
                      </NavLink> */}
                    </>
                  }
                  <SignOutContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  companyDataValid: state.appState.companyDataValid,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchSetProjectDetail(projectDetail) {
    await dispatch(setProjectDetail(projectDetail));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
